if($('#header').length) {
	$('.top-navigation-bar .top-navigation-tools a.login').appendTo('.navigation-buttons').removeClass('toggle-window');
  $('.top-navigation-bar .top-navigation-tools a.top-nav-button-account').appendTo('.navigation-buttons').removeClass('toggle-window');
  $('<a class="contact-button" href="/kontakty/">Nová poptávka</a>').appendTo('.navigation-buttons');
  $('.responsive-tools [data-target=search]').clone().prependTo('.navigation-buttons');
  $('.responsive-tools [data-target=navigation]').clone().appendTo('.navigation-buttons');
}